import { ScrollTrigger } from "gsap/ScrollTrigger";
import { gsap } from "gsap";

const ApplicationsBox = () => {
	const block = document.querySelectorAll(".applications-box");
	if (!block) {
		return;
	}

	block.forEach((el) => {
		gsap.registerPlugin(ScrollTrigger);

		const list = el.querySelector(".applications-box__list");
		const listTicker = el.querySelector(".applications-box__list .ticker");
		const cursor = el.querySelector(".applications-box__cursor");
		if (!list) {
			return;
		}
		let links = null;
		let initAnimation = false;
		let centerLinkIndex = 0;
		const isMobile = window.innerWidth < 768;
		const TL = gsap.timeline({
			onComplete: () => {
				listTicker.dispatchEvent(new Event("ticker-play"));
			}
		});
		TL.pause();
		listTicker.dispatchEvent(new Event("ticker-pause"));

		const initAnim = () => {
			links = el.querySelectorAll(".applications-box__list .ticker__row:first-child .ticker__link");
			const centerScreen = window.innerWidth / 2;
			if (isMobile) {
				centerLinkIndex = links.length - 2;
			} else {
				links.forEach((link, index) => {
					if (link.offsetLeft < centerScreen && centerScreen < link.offsetLeft + link.offsetWidth) {
						centerLinkIndex = index;
					}
				});
			}

			const positionFirst = links[centerLinkIndex].getBoundingClientRect();
			const positionNext = links[centerLinkIndex + 1].getBoundingClientRect();

			TL.fromTo(cursor, { left: '100%', scale: 0.5, opacity: 0 }, { left: positionFirst.left + 50, scale: 1, opacity: 1, duration: 0.4 }, 0);
			TL.to(cursor, { scale: 0.8, duration: 0.2 }), 0.5;
			TL.to(cursor, { scale: 1, duration: 0.2 }, 0.7);
			TL.to(links[centerLinkIndex], { color: "#000", borderColor: "#000", duration: 0.2 }, 0.5);
			TL.to(links[centerLinkIndex], { color: "#555866", borderColor: "#555866", duration: 0.2 }, 0.9);

			TL.to(cursor, { left: positionNext.left + 50, y: isMobile ? 20 : 40, duration: 0.5 }, 1.1);
			TL.to(cursor, { scale: 0.8, duration: 0.2 }), 1.5;
			TL.to(cursor, { scale: 1, duration: 0.2 }, 1.7);
			TL.to(links[centerLinkIndex + 1], { color: "#000", borderColor: "#000", duration: 0.2 }, 1.5);
			TL.to(links[centerLinkIndex + 1], { color: "#555866", borderColor: "#555866", duration: 0.2 }, 1.9);
			TL.to(cursor, { left: '100%', y: 150, scale: 0, duration: 0.3 }, 2);
		};

		gsap.timeline({
			scrollTrigger: {
				trigger: block,
				start: "top 20%",
				scrub: true,
				onEnter: () => {
					initAnim();
					if (!initAnimation) {
						TL.play();
						initAnimation = true;
					}
				}
			}
		});
	});
};

export default ApplicationsBox;
